import {
  NewEducationLinkShape,
  NewInterviewShape,
  InterviewSetShape,
} from "../interfaces/classTypes";
import { NewInterview } from "./new_interview_class";

let allIncludedNewInterviewSets: InterviewSetShape[] = [];

export class InterviewSet {
  public id: number;
  public interviews: NewInterviewShape[];

  constructor(data: NewInterviewShape) {
    this.id = parseInt(Object.keys(data)[0]);
    this.interviews = Object.values(data)[0].map(
      (interview) => new NewInterview(interview, this.id)
    );
    this.save();
  }
  save() {
    allIncludedNewInterviewSets.push(this);
  }

  name() {
    return this.interviews[0].name;
  }

  find_target_interview_by_id(id) {
    return this.interviews.find((interview) => interview.id == id);
  }

  static find_by_interview_id(interviewId) {
    return allIncludedNewInterviewSets.filter((set) => {
      !!set.find_target_interview_by_id(interviewId);
    })[0];
  }

  static allIncludedInterviewSets() {
    return allIncludedNewInterviewSets;
  }

  static find_by_id(id) {
    return allIncludedNewInterviewSets.find((i) => i.id == parseInt(id));
  }
}
